var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2212 9.35345L10.3873 9.14406C10.1717 9.11873 9.9531 9.14261 9.74802 9.21389C9.54293 9.28517 9.35666 9.402 9.20322 9.55561L7.87471 10.8841C5.82506 9.84168 4.15908 8.17571 3.11665 6.12605L4.45237 4.79032C4.76284 4.47986 4.91446 4.04665 4.86392 3.60622L4.65454 1.78675C4.6136 1.43454 4.44457 1.10967 4.17962 0.874018C3.91468 0.638361 3.57232 0.508369 3.21773 0.50879H1.96865C1.15278 0.50879 0.474084 1.18748 0.524625 2.00336C0.907292 8.16934 5.83864 13.0935 11.9974 13.4761C12.8133 13.5267 13.492 12.848 13.492 12.0321V10.783C13.4992 10.0538 12.9505 9.44009 12.2212 9.35345Z",
    fill: "#22AD01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGreen);
export default __webpack_public_path__ + "static/media/phone-green.b41bd6c516a01c205afa4885165d15dd.svg";
export { ForwardRef as ReactComponent };